import PropTypes from 'prop-types';

const TextField = ({ name, defaultValue, onChange }) => (
  <input
    type="text"
    className="critere-input"
    value={defaultValue.valeur || ''}
    title={defaultValue.valeur || ''}
    name={name}
    onChange={(event) => onChange({ valeur: event.target.value ?? '' })}
  />
);
TextField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default TextField;
